import {useQuery} from "@apollo/client";
import {IonModal, IonCheckbox} from "@ionic/react";
import {useState} from "react";

import {GET_PRIVACY_POLICY} from "../../../graphql/queries/policy.query";

import "../Attesa/attesa.style.css";

interface PrivacyModalProps {
  visible: boolean;
  dismiss: () => any;
  submitForm: () => any;
  type?: "order" | "quote" | "registration";
}

const AttesaPrivacyPolicy = (props: PrivacyModalProps) => {
  const privacyType = props.type ?? "order";

  const [privacyPolicy, setPrivacyPolicy] = useState({
    title: "",
    body: "",
    footer: "",
  });

  const [checked, setChecked] = useState(false);

  useQuery(GET_PRIVACY_POLICY, {
    fetchPolicy: "cache-and-network",
    variables: {
      type: privacyType,
    },
    onCompleted(data) {
      setPrivacyPolicy(data.getPrivacyPolicy.data);
    },
  });

  const closeModal = () => {
    setChecked(false);
    props.dismiss();
  };
  const acceptTerms = () => {
    props.submitForm();
    closeModal();
  };

  return (
    <IonModal
      isOpen={props.visible}
      swipeToClose={true}
      backdropDismiss={false}
      onDidDismiss={props.dismiss}
    >
      <div className="attesa-modal">
        <p className="attesa-policy-modal-title attesa-modal-title">
          {privacyPolicy?.title}
        </p>

        <div className="attesa-policy-buttons attesa-button-font">
          <button className="attesa-button-cancel" onClick={closeModal}>
            Annulla
          </button>
          <button
            className="attesa-button-save"
            disabled={!checked}
            onClick={acceptTerms}
          >
            INVIA
          </button>
        </div>
        <div
          className="attesa-policy-modal-body"
          dangerouslySetInnerHTML={{__html: privacyPolicy.body}}
        />
        <div className="attesa-policy-footer-with-checkbox">
          <div className="attesa-policy-footer-checkbox">
            <IonCheckbox
              color="primary"
              slot="start"
              checked={checked}
              onIonChange={(e) => {
                setChecked(e.detail.checked);
              }}
            />
          </div>
          <div
            className="attesa-policy-modal-footer"
            dangerouslySetInnerHTML={{
              __html: privacyPolicy.footer.replace(
                /{{url}}/gi,
                `${window.location.origin}/privacy-policy/${privacyType}`
              ),
            }}
          />
        </div>
      </div>
    </IonModal>
  );
};

export default AttesaPrivacyPolicy;
